import { Box } from 'grommet';
import React from 'react';

const NotFound = () => (
  <Box direction="row" border={{ color: 'brand', size: 'large' }} pad="medium">
    Not Found
  </Box>
);

export default NotFound;
